module.exports = __webpack_public_path__ + "img/logo_vuetify.668cf772.svg";